<template>
  <div class="function_box">
    <!-- 头像 -->
    <div class="user">
      <img src="../../assets/img/common/photo_replace.png" alt="">
    </div>
    <!-- 功能 -->
    <div class="function_button">
      <button @click="goRouter('/login/deal')" >交易訂單</button>
      <button @click="goRouter('/login/deal/settlement')">結算管理</button>
      <button @click="goRouter('/login/deal/bills')">交易帳單</button>
      <button @click="goRouter('/login/deal/moneybills')">資金帳單</button>
      <button @click="goRouter('/login/deal/record')">轉出/轉入記錄</button>
      <button @click="goRouter('/login/deal/certificates')">電子憑證</button>

    </div>
    <!--  -->
  </div>
</template>

<script>

export default {
  name: 'Function',
  props: {
  },
  data() {
    return {
      
    }
  },
  components: {
  },
	methods:{
		goRouter(index){
		  this.$router.push(index);
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.function_box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.user {
  /*  */
  background: url("../../assets/img/common/user_photo.png") no-repeat center;
  width: 140px;
  min-width: 140px;
  min-height: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 20px;
  }
.user > img {
  width: 27px;
  height: 27px;
}
.function_button {
  /*  */
  box-sizing: border-box;
  width: 700px;
  height: 100px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: flex-start;
  }
  .function_button button {
    box-sizing: border-box;
    padding: 5px 13px;
    margin: 13px 7px;
    border-radius: 10px;
    background: #f4f5f9;
  }
</style>
